__turbopack_context__.v({
  "avatar": "header2026-module__P-TR4G__avatar",
  "background": "header2026-module__P-TR4G__background",
  "barLinks": "header2026-module__P-TR4G__barLinks",
  "burgerLoggedOut": "header2026-module__P-TR4G__burgerLoggedOut",
  "burgerMenu": "header2026-module__P-TR4G__burgerMenu",
  "burgerOpen": "header2026-module__P-TR4G__burgerOpen",
  "centerBarLinks": "header2026-module__P-TR4G__centerBarLinks",
  "clearHeader": "header2026-module__P-TR4G__clearHeader",
  "content": "header2026-module__P-TR4G__content",
  "counter": "header2026-module__P-TR4G__counter",
  "counter--orange": "header2026-module__P-TR4G__counter--orange",
  "counter--teal": "header2026-module__P-TR4G__counter--teal",
  "desktop": "header2026-module__P-TR4G__desktop",
  "dimmedBackground": "header2026-module__P-TR4G__dimmedBackground",
  "footerAuthButtons": "header2026-module__P-TR4G__footerAuthButtons",
  "footerEnterButton": "header2026-module__P-TR4G__footerEnterButton",
  "headerAtTop": "header2026-module__P-TR4G__headerAtTop",
  "headerContainer": "header2026-module__P-TR4G__headerContainer",
  "headerScrollingUp": "header2026-module__P-TR4G__headerScrollingUp",
  "hideDimmedBackground": "header2026-module__P-TR4G__hideDimmedBackground",
  "hideOnMobile": "header2026-module__P-TR4G__hideOnMobile",
  "leftBarLinks": "header2026-module__P-TR4G__leftBarLinks",
  "logoColor__black": "header2026-module__P-TR4G__logoColor__black",
  "logoColor__grey": "header2026-module__P-TR4G__logoColor__grey",
  "logoColor__white": "header2026-module__P-TR4G__logoColor__white",
  "logoImage": "header2026-module__P-TR4G__logoImage",
  "logoImageWrapper": "header2026-module__P-TR4G__logoImageWrapper",
  "menu": "header2026-module__P-TR4G__menu",
  "menuAction": "header2026-module__P-TR4G__menuAction",
  "menuBar": "header2026-module__P-TR4G__menuBar",
  "menuBarBottom": "header2026-module__P-TR4G__menuBarBottom",
  "menuBarMiddle": "header2026-module__P-TR4G__menuBarMiddle",
  "menuBarTop": "header2026-module__P-TR4G__menuBarTop",
  "menuBreak": "header2026-module__P-TR4G__menuBreak",
  "menuClose": "header2026-module__P-TR4G__menuClose",
  "menuCloseLoggedIn": "header2026-module__P-TR4G__menuCloseLoggedIn",
  "menuCloseOne": "header2026-module__P-TR4G__menuCloseOne",
  "menuCloseTwo": "header2026-module__P-TR4G__menuCloseTwo",
  "menuContent": "header2026-module__P-TR4G__menuContent",
  "menuFooter": "header2026-module__P-TR4G__menuFooter",
  "menuHeader": "header2026-module__P-TR4G__menuHeader",
  "menuHeaderWithUser": "header2026-module__P-TR4G__menuHeaderWithUser",
  "menuHidden": "header2026-module__P-TR4G__menuHidden",
  "menuItem": "header2026-module__P-TR4G__menuItem",
  "menuItemSubpageTitle": "header2026-module__P-TR4G__menuItemSubpageTitle",
  "menuItems": "header2026-module__P-TR4G__menuItems",
  "menuItemsWrapper": "header2026-module__P-TR4G__menuItemsWrapper",
  "menuLoggedIn": "header2026-module__P-TR4G__menuLoggedIn",
  "menuOpen": "header2026-module__P-TR4G__menuOpen",
  "menuOpenDaymadeLogo": "header2026-module__P-TR4G__menuOpenDaymadeLogo",
  "menuUser": "header2026-module__P-TR4G__menuUser",
  "mobile": "header2026-module__P-TR4G__mobile",
  "notifyDot": "header2026-module__P-TR4G__notifyDot",
  "orderSummaryContainer": "header2026-module__P-TR4G__orderSummaryContainer",
  "rightBarLinks": "header2026-module__P-TR4G__rightBarLinks",
  "scrollHideEnabled": "header2026-module__P-TR4G__scrollHideEnabled",
  "scrollHideEnabledNavOpen": "header2026-module__P-TR4G__scrollHideEnabledNavOpen",
  "showDimmedBackground": "header2026-module__P-TR4G__showDimmedBackground",
  "subpage": "header2026-module__P-TR4G__subpage",
  "subpageOpen": "header2026-module__P-TR4G__subpageOpen",
  "userEmail": "header2026-module__P-TR4G__userEmail",
  "userInfo": "header2026-module__P-TR4G__userInfo",
  "userName": "header2026-module__P-TR4G__userName",
});
